import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import SubjectEdit from "./FinancialYearEdit";
import moment from 'moment';
import Confirm from '../Confirm';
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
//React Icons Ends here.


const SubjectList = () => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [isFinancialYearRec, setFinancialYearRec] = React.useState({});
  const [modalShowEditSubject, setModalShowEditSubject] = React.useState(false);


  useEffect(() => {
    console.log('inside the useEffect')
    fetchAllFinancialYears();
  }, []);

  const fetchAllFinancialYears = () => {
    async function init() {
      const financial = await trasportApi.fetchAllFinancialYears();
      if (financial) {
        setBody(financial);
      } else {
        setBody([]);
      }
    }
    init();
  }

  // Create table headers consisting of 4 columns.
  const header = [
    { title: "Year Name", prop: "name", isFilterable: true },
    {
      title: "Start Date",
      prop: "startdate",
      isSortable: true,
      cell: (row) => moment(row.startdate).format("YYYY-DD-MM"),
    },
    {
      title: "End Date",
      prop: "enddate",
      isSortable: true,
      cell: (row) => moment(row.enddate).format("YYYY-DD-MM"),
    },
    {
      title: "Is Active",
      prop: "isactive",
      isFilterable: true,
      cell: (row) => (
        
        <input type="checkbox" checked={row.isactive ? true:false}/>
      ),
    },
    // { title: "Is active", prop: "isactive", isFilterable: true },
    // {
    //   title: 'Actions', prop: 'id', cell: (row) => (
    //     <>
        
    //     </>
    //   )
    // }
  ];
  
    header.push({
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <div>
             <Button className='btn-sm mx-2' onClick={() => editFinancialYearList(row)}><FiEdit /></Button>
          <Button variant="danger" className='btn-sm mx-2' onClick={() => handleDelete(row)}><FaTrashAlt/></Button>
        </div>
      ),
    });


  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createSubject = () => {
    setFinancialYearRec({});
    setModalShowEditSubject(true);
  };

  const submitFinancialYearList = () => {
    // setModalShowCreateDoctorDuty(false);
    // setModalShowEditSubject(false);
    // fetchAllDuties();
    // setDoctorDuty({});
  }

  const editFinancialYearList = (row) => {
    setModalShowEditSubject(true);
    setFinancialYearRec(row);
  }

  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setFinancialYearRec(row);
  }
  const deleteFinancialYearRec = async () => {
    console.log("deleteFinancialYearRec ",isFinancialYearRec.id)
    const result = await trasportApi.deleteFinancialYear(isFinancialYearRec.id);
    //console.log('result',result)
    if (result.success) {
      setFinancialYearRec('');
      setModalShow(false);
      fetchAllFinancialYears();
    }
  }

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.SubjectList}</title>
        </Helmet>
      </>

      {modalShowEditSubject &&
        <SubjectEdit
          show={modalShowEditSubject}
          onHide={() => setModalShowEditSubject(false)}
          submitFinancialYearList={submitFinancialYearList}
          isFinancialYearRec={isFinancialYearRec ? isFinancialYearRec : {}}
        />
      }

      {modalShow &&
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteFinancialYearRec={deleteFinancialYearRec}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="financialYear"
        />}

      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight/>
          Financial List
        </Col>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions labels={labels} />
                  <InfoPill left="Total" right={body?.length} />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createSubject(true)}
                  >
                    New Financial Year
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default SubjectList;
